import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authService.isAuthenticated()) {
      if (
        _route.firstChild?.routeConfig?.path ===
        'my-profile/marketing-preferences'
      ) {
        this.authService.redirectAfterLogin = `/app/my-profile/marketing-preferences`;
      }

      // if not logged in, send back to the homepage i.e. the register/login page
      if (this.router.url.includes('eis')) {
        this.router.navigate(['/eis/home']).finally(() => false);
      } else {
        this.router.navigate(['']).finally(() => false);
      }
    }

    return true;
  }
}
